<template>
  <v-container
    class="container-mobile"
  >
    <v-row
      class="card"
    >
      <div class="mobile-underlay" />
      <v-col
        class="action-col"
        sm="12"
        md="7"
      >
        <div>
          <hero-text
            :logo="servicer.effective_company_logo_url"
            :title="servicer.borrower_web_content_setting_splash_header"
            :subtitle="servicer.borrower_web_content_setting_splash_subheader"
          />
        </div>
        <div>
          <action-input
            label-text="What's your email?"
            button-text="Continue"
            type="email"
            :rules="emailRules"
            @action-btn-clicked="actionInputClickHandler"
          />
        </div>
        <div
          v-if="$vuetify.breakpoint.lgAndUp"
          class="signin-cta sn-subtitle-1 sn-font-weight-regular sn-text-primary-04"
        >
          <p>
            Already have an account?
            <span
              class="signin-link sn-font-weight-semi-bold"
              @click="signinLinkClickHandler"
            >
              Sign In
            </span>
          </p>
        </div>
      </v-col>
      <v-spacer cols="1" />
      <v-col
        class="servicer-col d-flex"
        :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12"
        justify="end"
        align="center"
      >
        <slot />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ActionInput from '../Form/ActionTextInput.vue'
import HeroText from './HeroText.vue'

export default {
  name: 'HeroBanner',

  components: {
    ActionInput,
    HeroText
  },

  props: {
    servicer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      emailRules: [
        v => /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(v) || 'Please enter a valid E-mail'
      ]
    }
  },
  methods: {
    actionInputClickHandler (inputText) {
      const protocol = window.location.host.includes('localhost') ? 'http' : 'https'
      const host = window.location.host
      const route = '/borrower/onboarding/'
      const code = window.location.pathname.split('/')[3]
      const shareLinkFlag = this.servicer.feature_setting_force_mobile_web_signup_from_sharelink_enabled ? '&from_mobile_share=true' : ''
      const newPath = `${protocol}://${host}${route}${code}?email=${inputText}&code=${code}${shareLinkFlag}`
      window.location.href = newPath
    },
    signinLinkClickHandler () {
      window.location.href = '/login'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.card {
  margin: 4;
  padding: 73px 83px 53px;
  display: flex;
  background-color: $sn-white;
  border-radius: 16px;
}
.action-col h1 {
  margin-top: 35px
}
.title {
  margin-top: 35px;
  font-size: 48px !important;
}
.subtitle {
  padding-left: 12px;
  margin-top: 16px;
  margin-bottom: 40px;
}
.signin-link {
  cursor: pointer;
  text-decoration: underline;
}
.mobile-underlay {
  display: none;
}

@media screen and (max-width: $medium-screen-size) {
  .container-mobile {
    position: relative;
    border-radius: 16px 16px 0 0;
    background-color: $sn-white;
  }
  .card {
    flex-direction: column-reverse;
    align-items: center;
    padding: 45px 17px 10px;
  }
  .action-col {
    position: relative;
    margin: 0 -17px;
    padding: 40px 16px;
    border-radius: 8px;
    background-color: $sn-white;
    box-shadow: $sn-shadow-depth-2;
  }
  .servicer-col {
    justify-content: center;
    margin-top: -130px;
  }
  .mobile-underlay {
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 135px;
    margin: -12px;
    background-color: $sn-gray-01;
  }
}

@media screen and (min-width: $medium-screen-size + 1) {
  .card {
    box-shadow: $sn-shadow-depth-3;
  }
}
</style>
